import * as React from "react";
import { FastActionPartsTableActions } from "./FastActionPartsTableActions";


// Legacy export for backward compatibility
const columns = (onSelected, onAdd, onMinus, onRemove, t) => {
    return [
        {
            label: t ? t("common.name") : "Nazwa",
            field: "name",
            sort: "desc",
            width: 150
        },
        {
            label: t ? t("common.category") : "Kategoria",
            field: "fastActingPartCategory",
            sort: "desc",
            width: 150,
            render: function (row) {
                return row.fastActingPartCategory.name
            }
        },
        {
            label: t ? t("forms.minimal_state") : "Stan minimalny",
            field: "minimalQuantity",
            sort: "desc",
            width: 150
        },
        {
            label: t ? t("forms.state") : "Stan",
            field: "quantity",
            sort: "desc",
            width: 150
        },
        {
            field: "actions",
            label: t ? t("common.actions") : "Akcje",
            sort: "desc",
            width: 53,
            type: "custom",
            custom: function (column, row, history, reload, setReload, setLoader) {
                return <FastActionPartsTableActions
                    onSelected={() => {
                        onSelected(row);
                    }}
                    onAdd={() => {
                        onAdd(row);
                    }}
                    onMinus={() => {
                        onMinus(row);
                    }}
                    onRemove={() => {
                        onMinus(row);
                    }}
                    row={row}
                    history={row}
                    reload={reload}
                    setReload={setReload}
                    setLoader={setLoader}
                />
            }
        }
    ];
};

export default columns;